'use client';

import type { FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import type { DisplayProps, MarginProps } from '../../utils/spacing';
import type { RevealProps } from '../Reveal';
import { Reveal } from '../Reveal';
import styles from './DividerVertical.module.css';

export interface DividerVerticalProps
  extends DisplayProps, MarginProps, RevealProps {
  className?: string;
  disabledReveal?: boolean;
}

export const DividerVertical: FC<PropsWithChildren<DividerVerticalProps>> = (
  props
) => {
  const { className, disabledReveal } = props;
  const revealProps: RevealProps = {};

  if (disabledReveal) {
    revealProps.activeOpacity = 1;
    revealProps.inactiveOpacity = 1;
  }

  return (
    <Reveal
      {...revealProps}
      {...props}
      className={cx(styles.root, className)}
    />
  );
};
